import React__default from 'react';
import { D as Dialogue } from './Dialogue-baf82d85.js';
import { B as Button } from './Button-a85bccb9.js';
import { u as useStrings } from './className-ac5eca03.js';

const EmptyTableRow = ({ message, size }) => {
    const className = `EmptyTableRow EmptyTableRow-${size}`;
    return React__default.createElement("div", { className: className },
        " ",
        message,
        " ");
};

const ConfirmDialogue = props => {
    var _a, _b;
    const { buttons: strings } = useStrings();
    const buttons = [
        React__default.createElement(Button, { key: "cancel", disabled: props.isBusy, variant: "outlined", onClick: props.onCancel }, (_a = props.cancelTitle) !== null && _a !== void 0 ? _a : strings.cancel),
        React__default.createElement(Button, { key: "confirm", variant: props.isDangerous ? 'danger' : undefined, busy: props.isBusy, onClick: props.onConfirm }, (_b = props.confirmTitle) !== null && _b !== void 0 ? _b : strings.ok)
    ];
    return React__default.createElement(Dialogue, { className: props.className, ariaLabel: props.title, isOpen: props.isOpen, onClose: props.onCancel },
        React__default.createElement(Dialogue.Header, { title: props.title }),
        React__default.createElement(Dialogue.Content, null, props.children),
        React__default.createElement(Dialogue.Footer, { buttons: buttons }));
};

export { ConfirmDialogue as C, EmptyTableRow as E };
